import type { OfficeIdentity } from "@/api/schemas";

/** One mapa record as the MapeFields editor creates it. */
export interface MapaRow {
  redni_broj: string;
  struka: string;
  oznaka_projekta: string;
  izradivac: { tvrtka: string; adresa: string };
  projektant: { ime: string; titula: string; broj_ovlastenja: string };
}

/**
 * S1 — "Dodaj mapu" prefill: a brand-new row starts with the office's own
 * identity (izrađivač = the office, projektant = glavni projektant from
 * the global office settings) because that is the right answer for the
 * first mapa of almost every project. Strictly fill-empty: this only ever
 * seeds a NEW row — existing rows and hand-typed values are never touched,
 * and a missing office profile degrades to the old blank row.
 */
export function newMapaRow(
  existingCount: number,
  office?: OfficeIdentity | null,
): MapaRow {
  return {
    redni_broj: String(existingCount + 1),
    struka: "",
    oznaka_projekta: "",
    izradivac: {
      tvrtka: office?.name_full ?? "",
      adresa: office?.ured_addr ?? "",
    },
    projektant: {
      ime: office?.gp_name_full ?? "",
      titula: "",
      broj_ovlastenja: office?.hka_broj ?? "",
    },
  };
}
